var teamMap = {
  id: 'id',
  name: 'name',
  businessEntityName: 'businessEntityName',
  businessTradingName: 'businessTradingName',
  businessAddress: 'businessAddress',
  flags: 'flags',
  planId: 'planId',
  parentTeamId: 'parentTeamId',
  preferences: 'preferences',
  reasonCodes: 'reasonCodes',
  subteams: 'subteams',
  dateCreated: 'dateCreated',
  dateModified: 'dateModified'
};
export default teamMap;